import React from 'react';

import LoadingIcon from 'icons/loading.svg';
import PropTypes from 'prop-types';

import Toast from 'components/application/Toast';

export default function LoadingToast({
  additionalContent,
  message,
  onBurnToast,
  toastKey,
}) {
  return (
    <Toast
      burn={onBurnToast}
      burnTimer={null}
      contents={
        <>
          <div className='toast__icon'>
            <div className='tw-apply-loading-spinner--blue-light'>
              <LoadingIcon height={20} width={20} />
            </div>
          </div>
          <div className='toast__text'>{message}</div>
          {additionalContent}
        </>
      }
      modifiers='no-undo'
      toastKey={toastKey}
    />
  );
}

LoadingToast.propTypes = {
  message: PropTypes.node,
  additionalContent: PropTypes.node,
  onBurnToast: PropTypes.func,
  toastKey: PropTypes.string,
};
